import api from './client'
import type { AttendanceLateType, AttendanceRecord, AttendanceRecordList, AttendanceShift, AttendanceStatus } from '../types'

export interface AttendanceListParams {
  employeeId?: string
  startDate?: string
  endDate?: string
  status?: AttendanceStatus
  lateOnly?: boolean
  lateWithPermissionOnly?: boolean
}

export interface LateConfirmationPayload {
  lateType?: AttendanceLateType
  lateReason?: string
  lateAcknowledgedText?: string
  timeZone?: string
}

const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Brisbane'

const serializeParams = (params?: AttendanceListParams) => ({
  ...params,
  lateOnly: params?.lateOnly ? 'true' : undefined,
  lateWithPermissionOnly: params?.lateWithPermissionOnly ? 'true' : undefined,
})

export const attendanceApi = {
  getToday: () =>
    api.get<{ data: AttendanceRecord }>('/attendance/today', { params: { timeZone: browserTimeZone() } }),

  startDay: (data?: LateConfirmationPayload) =>
    api.post<{ data: AttendanceRecord }>('/attendance/start-day', { timeZone: browserTimeZone(), ...(data || {}) }),

  startBreak: () =>
    api.post<{ data: AttendanceRecord }>('/attendance/start-break'),

  endBreak: () =>
    api.post<{ data: AttendanceRecord }>('/attendance/end-break'),

  finishDay: () =>
    api.post<{ data: AttendanceRecord }>('/attendance/finish-day'),

  finishDayWithReason: (data: { workLogShortfallReason: string }) =>
    api.post<{ data: AttendanceRecord }>('/attendance/finish-day', data),

  listRecords: (params?: AttendanceListParams) =>
    api.get<{ data: AttendanceRecordList }>('/attendance/records', { params: serializeParams(params) }),

  listShifts: () =>
    api.get<{ data: AttendanceShift[] }>('/attendance/shifts'),

  updateShift: (userId: string, data: { shiftStartTime: string; timeZone?: string }) =>
    api.put<{ data: { id: string; userId: string; shiftStartTime: string; timeZone: string } }>(`/attendance/shifts/${userId}`, data),

  getSettings: () =>
    api.get<{ data: { slackChannelId: string } }>('/attendance/settings'),

  updateSettings: (data: { slackChannelId: string }) =>
    api.put<{ data: { slackChannelId: string } }>('/attendance/settings', data),
}
